/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-unresolved */
import * as yup from 'yup';
import moment from 'moment';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { setAlert } from '@/store/slices/alert';
import { phoneRegex } from './constants';
import { ItemType } from '@/types/utils';

// Validation Schema for Forms
export const validationSchema = {
  password: yup
    .string()
    .required('Password is required')
    .min(5, 'Password must be 5 characters or more'),
  passcode: yup
    .string()
    .required('Passcode is required')
    .min(4, 'Passcode must be 4 characters or more'),
  email: yup.string().email('Invalid Email Address').optional(),
  url: yup.string().required('URL is required'),
  phoneNumber: yup
    .string()
    .optional()
    .matches(phoneRegex, 'Invalid Phone number')
    .min(11, 'Not a valid phone number'),
  dynamic: (title: string) => yup.string().required(`${title} is required`),
  optional: () => yup.string().optional(),
};

// HOC for dispatching Error Alerts
export const dispatchErrorAlerts =
  (message: string) => (dispatch: ThunkDispatch<unknown, any, any>) =>
    dispatch(setAlert({ type: 'error', message }));

// HOC for dispatching Success Alerts

export const dispatchSuccessAlerts =
  (message: string) => (dispatch: ThunkDispatch<unknown, any, any>) =>
    dispatch(setAlert({ type: 'success', message }));

// Format Date
export const formatDate = (date: string) => {
  const convertDate = new Date(date);

  const formattedDate = convertDate.toDateString().slice(4);

  return formattedDate;
};

// Format Cart Time
export const cartCreated = (date: string) => {
  const time = moment(date).format('MM-DD-YYYY/ h:mm a');

  return time;
};

// Get Filtered result when a search occurs
export const getFilteredResults = (items: any[], filterKey: string) => {
  const filteredItems = items?.filter(
    (customer: any) =>
      // eslint-disable-next-line implicit-arrow-linebreak
      Object.values(customer)
        .join(' ')
        .toLowerCase()
        .includes(filterKey.toLowerCase()),
    // eslint-disable-next-line function-paren-newline
  );

  return filteredItems;
};

// Convert data to the exact format needed on the cart redux store
export const convertItemsToCartFormat = (itemsList: ItemType[]) => {
  let newItemObj;
  if (itemsList) {
    newItemObj = itemsList.map((item: any) => ({
      item_code: item.item_code,
      item_group: item.item_group,
      item_name: item.item_name,
      description: item.item_name,
      stock_uom: item.stock_uom,
      qty: item.qty,
      currency: 'NGN',
      price_list_rate: item.price_list_rate,
    }));
  }

  return newItemObj;
};

// THIS GETS PAYMENT MODES

export const getPaymentModes = (paymentArray: any) => {
  const paymentModes = paymentArray.reduce((modes: any, payment: any) => {
    if (payment.hasOwnProperty('mode_of_payment')) {
      modes.add(payment.mode_of_payment);
    }
    return modes;
  }, new Set());

  if (paymentModes.size > 1) {
    return Array.from(paymentModes).sort().join(' & ');
  }
  if (paymentModes.size === 1) {
    return paymentModes.values().next().value;
  }
  return '';
};

export const handleGetPaymentMethod = (
  payments: Array<Record<string, any>>,
) => {
  const paymentMethods = payments.map((payment) => ({
    type: payment.mode_of_payment,
    amount: payment.amount,
  }));

  return paymentMethods;
};

// ERROR HANDLING

export const handleApiError = (data: any) => {
  const serverMessages = data.response.data._server_messages;
  const errorData = JSON.parse(JSON.parse(serverMessages)[0]).message;

  return errorData;
};
